import { z } from 'zod';

// * Define contract schemas using zod
export const RevisionsSchema = z.object({
  name: z.string(),
  _id: z.string(),
  revisionNumber: z.number(),
  isMainRevision: z.boolean(),
  createdAt: z.string(),
  createdBy: z.string(),
});

export const RevisionsSchemaCreate = RevisionsSchema.omit({ _id: true });

export const RevisionsSchemaUpdate = RevisionsSchema.pick({ name: true });

export const RevisionsSchemaUpdateMainRevision = RevisionsSchema.pick({
  isMainRevision: true,
});
